import { createActions } from 'redux-actions';

export const actions = createActions({
  EXPERT_INPUT: {
    SET_ACTIVE_EXPERT_INPUT: id => id,
  },
}).expertInput;
